import React from 'react'
import { Helmet } from 'react-helmet'
import CustomCursor from './CustomCursor'

const Layout = ({
  title,
  description = "Sarvadnya Awaghad - Full Stack Developer Portfolio. Explore my projects, skills, and experience.",
  keywords = "Sarvadnya Awaghad, Web Developer, React Developer, Portfolio, Software Engineer",
  children
}) => {
  return (
    <div>
      <CustomCursor />
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content="Sarvadnya Awaghad" />
        <link rel="icon" href="https://res.cloudinary.com/dbszbhg8n/image/upload/v1680347659/Screenshot_2023-04-01_163808_rqjrag.png" type="image/png" sizes="16x16" />
      </Helmet>
      <div>{children}</div>
    </div>
  )
}

export default Layout
